<div class="w-100 float-left">
    <h5 class="b-b pb-3 medium">{{'emailHistory'|translate}}</h5>
    <!-- FILTERS -->
    <div class="w-100 float-left p-3 light-bg mt-3">
        <h6 class="medium mb-0"> {{'filters'|translate}} </h6>
        <div class="form-group mt-2 w-75 d-inline-flex relative">
            <div class="relative w-75">
                <input type="text" class="form-control" [(ngModel)]="searchBodyOrSubject"
                       (keyup.enter)="searchBodyOrSubjectFunc()">
                <i class="fa fa-caret-down tr-0" (click)="isCollapsed = !isCollapsed"
                   [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"></i>
            </div>
            <button class="btn btn-primary" (click)="searchBodyOrSubjectFunc()"> {{'search'|translate}}</button>
            <div class="w-75 absolute top-100 left-0 p-3 white-bg z-i shadow" id="collapseExample"
                 [ngbCollapse]="!isCollapsed">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium">{{'To'|translate}}</label>
                            <input type="text" class="form-control" [(ngModel)]="searchTo">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium">{{'CC'|translate}}</label>
                            <input type="text" class="form-control" [(ngModel)]="searchCc">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium">{{'subject'|translate}}</label>
                            <input type="text" class="form-control" [(ngModel)]="searchSubject">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium">{{'Group'|translate}}</label>
                            <select class="form-control" [(ngModel)]="selectedGroup">
                                <option *ngFor="let groups of notificationGroups" [value]=groups>{{groups}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium">{{'status'|translate}}</label>
                            <select class="form-control" [(ngModel)]="selectedStatus">
                                <option *ngFor="let status of notificationStatus" [value]=status>{{status |
                                    translate}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group w-100">
                            <label class="medium">{{'type'|translate}}</label>
                            <select class="form-control" [(ngModel)]="selectedTypes">
                                <option *ngFor="let types of notificationTypes" [value]=types>{{types}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-link float-left" (click)="resetFilter()">{{'resetKey'|translate}}
                        </button>
                        <button class="btn btn-primary float-right ml-3" (click)="applyFilter()">{{'apply'|translate}}
                        </button>
                        <button class="btn btn-light float-right" (click)="isCollapsed = !isCollapsed"
                                [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                            {{'close'|translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="w-100 float-left my-4">
        <button class="btn btn-primary float-right" (click)="createPerformancePgm()"> Send selected notifications </button>
        <button class="btn btn-secondary float-right mr-4"> Send notifications by filter </button>
    </div> -->
    <div class="w-100 float-left">
        <div class="w-100 float-left">
            <div class="light-bg w-100 float-left p-2 grid-details">
                <!--  <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                     <div class="checkbox checkbox-primary"><input id="checkbox2" type="checkbox"><label for="checkbox2" class="mb-md-0"></label></div>
                 </div> -->
                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> {{'notificationDesc'|translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> {{'notificationType'|translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> {{'notificationStatus'|translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> {{'createdOn'|translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> {{'empEmail'|translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <h6 class="mb-lg-0 medium"> {{'preview'|translate}} </h6>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details"
                 *ngFor="let email of emailNotificationData ; let i= index">
                <!--  <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                     <div class="checkbox checkbox-primary"><input id="checkbox3" type="checkbox"><label for="checkbox3" class="mb-md-0"></label></div>
                 </div> -->
                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 text-truncate text-primary" ngbTooltip="{{email.subject}}">
                        {{email.subject}} </h6>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 text-truncate" ngbTooltip="{{email.notificationType | translate}}">
                        {{email.notificationType | translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 text-truncate">{{email.status | translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 text-truncate">{{email.date | translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 text-truncate" *ngIf="email.to[0]">{{email.to[0]}} </h6>
                    <h6 class="mb-lg-0 text-truncate" *ngIf="!email.to[0] ">{{'NA' | translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <i class="fa fa-envelope" (click)="previewEmail(email)"></i>
                </div>
            </div>
        </div>
        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked()">
            <h6 class="float-left mb-0">
                {{((emailFilter.page-1)*emailFilter.pageSize)+1}}-{{emailFilter.pageSize*(emailFilter.page-1)+emailPageData.data?.numberOfElements}}
                {{'itemsOf' | translate}} {{emailPageData.data?.totalElements}} </h6>
            <div class="float-left ml-2 align-v-center">
                <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
                <select class="form-control float-left w-auto ml-2 mb-0" name="pageSize"
                        [(ngModel)]="emailFilter.pageSize" (change)="OnPageSizeChanged($event.target.value)">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
            </div>
            <div style="flex-grow: 1;"></div>
            <!-- <ngb-pagination [collectionSize]="120" [(page)]="page" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true" class="float-right"></ngb-pagination>
        </div> -->
            <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [maxSize]="5"
                            [pageSize]="emailFilter.pageSize" [ellipses]="false"
                            [(page)]="emailFilter.page" [boundaryLinks]="true" (pageChange)="getMails()"
                            class="float-right"></ngb-pagination>
            <div (click)="onRefresh()" data-toggle="tooltip" data-placement="bottom" title="Refresh"
                 style="margin-right:1px; margin-left:10px;cursor: pointer;"><i class="fa fa-refresh"
                                                                                aria-hidden="true"></i></div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/programManagement/emailNotification/emailNotification.html